"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkHeadingLevels = exports.useLevel = exports.H = exports.Level = exports.LevelContext = void 0;
const react_1 = __importStar(require("react"));
exports.LevelContext = react_1.default.createContext(1);
function Level(_ref) {
  let {
    children,
    value
  } = _ref;
  const contextLevel = react_1.useContext(exports.LevelContext);
  const level = levelRange(value !== undefined ? value : contextLevel + 1);
  return react_1.default.createElement(exports.LevelContext.Provider, {
    value: level
  }, children);
}
exports.Level = Level;
function H(_ref2) {
  let {
    children,
    offset,
    ...otherProps
  } = _ref2;
  const contextLevel = react_1.useContext(exports.LevelContext);
  const proposedLevel = contextLevel + (offset !== undefined ? offset : 0);
  const level = levelRange(proposedLevel);
  const Heading = `h${level}`;
  if (!isProd()) setTimeout(checkHeadingLevelsDom, CHECK_AFTER_MS);
  return react_1.default.createElement(Heading, Object.assign({}, otherProps), children);
}
exports.H = H;
function levelRange(level) {
  if (level > 0 && level <= MAXIMUM_LEVEL) {
    return level;
  }
  const errorMessage = `Heading level "${level}" is not valid HTML5 which only allows levels 1-${MAXIMUM_LEVEL}`;
  if (!isProd()) {
    throw Error(`${errorMessage}${exceptionOnDev}`);
  }
  return Math.min(Math.max(1, level), MAXIMUM_LEVEL);
}
function useLevel() {
  const contextLevel = react_1.useContext(exports.LevelContext);
  if (!isProd()) setTimeout(checkHeadingLevelsDom, CHECK_AFTER_MS);
  return levelRange(contextLevel);
}
exports.useLevel = useLevel;
function checkHeadingLevelsDom() {
  if (typeof window === "undefined") return; // No need to run during SSR
  checkHeadingLevels(Array.from(document.querySelectorAll("h1,h2,h3,h4,h5,h6")).map(elm => parseFloat(elm.tagName.substring(1))));
}
function checkHeadingLevels(headings) {
  const badHeadings = getBadHeadings(headings);
  if (badHeadings.length > 0) {
    const errorMessage = `Invalid heading levels detected: ${badHeadings}`;
    if (!isProd()) {
      throw Error(`${errorMessage}${exceptionOnDev}`);
    }
    console.error(errorMessage);
  }
  return badHeadings;
}
exports.checkHeadingLevels = checkHeadingLevels;
function getBadHeadings(headings) {
  return headings.filter(
  // multiple H1s are not recommended. See docs.
  heading => heading === 1).length >= 2 || headings.some((heading, index, arr) => {
    // detect skipped levels
    const precedingHeading = arr[index - 1];
    if (!precedingHeading) return false;
    return heading > precedingHeading + 1;
  }) ? headings : [];
}
function isProd() {
  // assume prod unless proven otherwise
  return !process || !process.env || process.env.NODE_ENV === "production";
}
const exceptionOnDev = ". This exception is only thrown in non-production environments.";
const MAXIMUM_LEVEL = 6;
const CHECK_AFTER_MS = 1; // will be clamped to ~5ms